import { DraggedSingleData } from "../../../../components/ui/DragToolsUI";
import { HudActions } from "../../../../components/ui/hud/HUDUI";
import BaseScenarioPart from "../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { constants } from "../../../../misc/constants";
import { DaarcBaseScenario } from "../../../DaarcBaseScenario";
import GeneralNeutralStateMain, { GeneralNeutralStateMainConfig, GeneralNeutralStatePart3Config } from "../GeneralNeutralStateMain";


export default class GeneralNeutralStatePart3 extends BaseScenarioPart<DaarcBaseScenario> {
	private alreadyDone = false;
	private get config(): GeneralNeutralStatePart3Config {
		return this.scenarioConfig.part3Config;
	}
	constructor(private main: GeneralNeutralStateMain, private _scenario: DaarcBaseScenario, private onDone: () => void, private id: string, private scenarioConfig: GeneralNeutralStateMainConfig) {
		super(_scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		const context = this;
		context._scenario.currentTaskMessage = 'Please setup suction';
		context._scenario.uiWrapper.displayHUD({
			score: context._scenario.totalScore,
			maxScore: this._scenario.maxScore,
			onActionClicked: (actionType: HudActions) => {
				if(context.main.onHudActionClicked(actionType)) {
					return true;
				}
				switch(actionType) {
					case HudActions.SetupSuction:
						context.setUpSuction();
						return true;
					default:
						if(context.config.onSettingUpAnythingElse) {
							context.config.onSettingUpAnythingElse();
						}
						context._scenario.displayMessage(context._scenario.currentTaskMessage);
						return false;
				}
			}
		}, context._scenario.hudId);

		if(!context.main.config.isEmanuelMcKenzie) {
			context.scenario.toolbagId = context._scenario.uiWrapper.displayToolbag({
				onShouldShowOverlay: () => {
					return false;
				},
				onToolClicked: (data: DraggedSingleData) => {
					context._scenario.displayMessage(context.scenarioConfig.isTestScenario ? context.main.toolsMessageTestScenario : context._scenario.currentTaskMessage);
				}
			}, context._scenario.toolbagId);
		}
	}

	public setUpSuction() {
		const context = this;

		if(!context.alreadyDone) {
			context._scenario.addScore(context._scenario.setSuctionPoints);
			context.alreadyDone = true;
		}
		// context.scenario.debriefLog('Suction Set');
		if(context.config.onSuctionSet) {
			context.config.onSuctionSet();
		}
		var onDoneWithPopup = context._scenario.doSomething('Setting up suction...');
		context.playVideoChapter(context.config.waitForSuctionVideoChapter(), () => {
			context.main.loopVideo(context, context.main.config.part1Config.hudIdleVideoChapter());
		})
		setTimeout(() => {
			onDoneWithPopup();
			context.onDone();
		}, constants.doSomethingTimeout);
	}
}